import styled from 'styled-components';

export const Container = styled.div`
  color: #fff;

  .MuiButtonBase-root {
    height: 107px;
    width: 107px;
    box-shadow: 0px 3.14124px 23.5593px rgba(0, 0, 0, 0.1);
    border-radius: 3.76284px;
    background-color: ${(props) => (props.selected ? '#0384AC' : '#cbcbcb')};
    display: flex;
    flex-direction: column;
    padding: 15px;
  }

  #icon {
    display: flex;
    align-items: center;
    justify-content: center;

    svg,
    span {
      font-size: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 55px;
      object-fit: contain;
    }
  }

  #text {
    height: 30%;
    display: flex;
    align-items: center;
    margin-top: 10px;

    > .MuiTypography-root {
      font-size: 13px;
      font-weight: 600;
      line-height: normal;
    }
  }
`;
